<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ProductForm :baseProduct="product" :baseproductName="name" :loading="loading" @submit-requested="submitRequested"></ProductForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import ProductForm from './ProductForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                product: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { ProductForm },
        computed:
        {
            ...mapState('products', ['getProductByIdOutput']),
        },
        methods: {
            ...mapActions('products', ['getProductById']),
            ...mapActions('products', ['putProduct']),
            submitRequested(product) {
                this.putProduct(product);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "ProductsList"});
            }
            else {
                this.getProductById(this.$route.query.id);
            }
        },
        watch:
        {
            getProductByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({name: "ProductsList"});
                }
                else {
                    this.product = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>